import { render, staticRenderFns } from "./CreacionProspecto.vue?vue&type=template&id=ef75d1e6&scoped=true"
import script from "./CreacionProspecto.vue?vue&type=script&lang=js"
export * from "./CreacionProspecto.vue?vue&type=script&lang=js"
import style0 from "./CreacionProspecto.vue?vue&type=style&index=0&id=ef75d1e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef75d1e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VImg,VRow})
